import { API_URL } from '../../config/connect';

const getModerationAnalytics = async (params = {}) => {
  try {
    const token = localStorage.getItem("google_id_token");
    
    if (!token) {
      throw new Error("No token found. User is not signed in.");
    }

    const queryParams = new URLSearchParams();
    if (params.timeRange) queryParams.append('timeRange', params.timeRange);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.categoryId) queryParams.append('categoryId', params.categoryId);

    const endpoint = `${API_URL}/api/v1/moderation/analytics${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

    const response = await fetch(endpoint, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching moderation analytics:', error);
    throw error;
  }
};

export default getModerationAnalytics;

